import React from 'react';

const ErrorBoundaryUI: React.FC = () => {
  return <div>Ocurrió un problema. Vuelve a internar más tarde</div>;
};

export default ErrorBoundaryUI;
